import Article from './components';

export default Article;
